/**
 * @module components\progress
 */
import Vue from "vue";
import { Component, Prop, Watch, Model } from "vue-property-decorator";

@Component
export default class GhProgress extends Vue {
  @Prop()
  show!: boolean;

  private isShow: boolean = false;

  @Watch("show")
  private setVisible() {
    this.isShow = this.show;
  }
}
